import React from 'react'
import { Body2 } from '@gousto-internal/citrus-react'

import styled from '@emotion/styled'
import {
  cssExtraInformation,
  cssLabelContainer,
  cssPerServingText,
  cssSoldOutText,
  cssSurchargeAmountText,
  cssTitleContainer,
  cssTitleText,
  cssTitleActive,
} from './styles'

import { formatSurcharge } from '../../../utils/formatSurcharge'

type ItemContentProps = {
  recipeName: string
  isOutOfStock: boolean
  surcharge: number | null
  isChecked?: boolean
}

const LabelContainer = styled.div(cssLabelContainer as any)
const TitleContainer = styled.div(cssTitleContainer as any)
const Title = styled(Body2)(
  (props: any) => (props.isChecked ? { ...cssTitleText, ...cssTitleActive } : cssTitleText) as any,
)
const ExtraInformation = styled.div(cssExtraInformation as any)
const SurchargeAmountText = styled(Body2)(cssSurchargeAmountText as any)
const PerServingText = styled.span(cssPerServingText as any)
const SoldOutText = styled.span(cssSoldOutText as any)

export function ItemContent({
  recipeName,
  isOutOfStock,
  surcharge = null,
  isChecked,
}: ItemContentProps) {
  return (
    <LabelContainer>
      <TitleContainer>
        <Title isChecked={isChecked}>{recipeName}</Title>
      </TitleContainer>
      {surcharge && !isOutOfStock && (
        <ExtraInformation>
          <SurchargeAmountText>{formatSurcharge(surcharge)}</SurchargeAmountText>
          <PerServingText>per serving</PerServingText>
        </ExtraInformation>
      )}
      {isOutOfStock && <SoldOutText>Sold out</SoldOutText>}
    </LabelContainer>
  )
}
